import {PAGE_SIZES} from '../../constants/search'

export const toPageSize = (pageSize: number | null | string) => {
    if (!pageSize || isNaN(+pageSize)) return Math.min(...PAGE_SIZES)
    return Math.min(+pageSize, Math.max(...PAGE_SIZES))
}